    import { bind } from "@okta/okta-auth-js";
import { CategoryDetail, CommentDetail, FunctionDetail, Organization, ProgramContainer } from "../../entities/formTemplateDataType";
import { CMARole, TemplateStatus } from "../../entities/Constants";

export const getOrganization = (programContainer?: ProgramContainer): Organization => {
    const owner = programContainer.createdById?.toLowerCase();
    console.log(programContainer?.OrganizationList)
    const orgs = programContainer?.OrganizationList?.filter(
        org => org.Lead1?.Email?.toLowerCase() === owner || org.Lead2?.Email?.toLowerCase() === owner
    );
    console.log(orgs)
    return orgs?.[0];
}

export const getCurrentTemplate = (programContainer: ProgramContainer) => {
    return programContainer.CMATemplateList?.find(template => template.Name === programContainer.Template);
}

export const getCurrentFunctions = (programContainer: ProgramContainer) => {
    return getCurrentTemplate(programContainer)?.Functions;
}

export const getCurrentFunction = (programContainer: ProgramContainer, bindName: string) => {
    const functions = getCurrentFunctions(programContainer);
    return functions?.map(func => {
        const index = func.CategoryDetailList.findIndex(cate => cate.SubcategoryNameList.includes(bindName));
        return index >= 0 ? func: null;
    })?.filter(Boolean)?.[0];
}

export const getCategoryFromFunction = (bindName: string, Function: FunctionDetail) => {    
    return Function?.CategoryDetailList?.map(c => {
        const index = c.SubcategoryNameList.findIndex(sub => sub === bindName);
        return index >= 0 ? c : null;
    }).filter(Boolean)[0];
}

export const getCategoryName = (programContainer: ProgramContainer, bindName: string) => {
    const name = getCurrentFunctions(programContainer)?.map(func => {
        const index = func.CategoryDetailList.findIndex(cate => cate.SubcategoryNameList.includes(bindName));
        return index >= 0 ? func.CategoryNameList[index] : null;
    })?.filter(Boolean)?.[0];
    return name;
}

export const getSelectedCategroy = (programContainer: ProgramContainer, bindName: string) => {
    return  getCurrentFunctions(programContainer)?.map(func => {
        const index = func.CategoryDetailList.findIndex(cate => cate.SubcategoryNameList.includes(bindName));
        return index >= 0 ? func.CategoryDetailList[index] : null;
    })?.filter(Boolean)?.[0];
}

export const setComments = (programContainer: ProgramContainer, categoryName: string) => {
    const category = getSelectedCategroy(programContainer, categoryName);
    category.CommentsList = programContainer.cmaComments;
}

export const commentsEqual = (comments1?: CommentDetail[], commnet2?: CommentDetail[]) => {
    if (!comments1 || !commnet2 || comments1.length !== commnet2.length) return false;
    return JSON.stringify(comments1) === JSON.stringify(commnet2);
}

export const commentsAccessible = (programContainer: ProgramContainer) => {
        let read = false;
        let edit = false;
        let write = false;
        
        const cmaRole = programContainer.userRole === 'Assessor' ? CMARole.ASSESSOR : programContainer.userRole === 'Approver' ? CMARole.APPROVER : CMARole.CS_ADMIN;
        const status = programContainer.Entity?.status;
        if (cmaRole === CMARole.ASSESSOR) {
            edit = [TemplateStatus.ASSIGNED, TemplateStatus.IN_PROGRESS, TemplateStatus.REVISION].includes(status);
            read = [TemplateStatus.APPROVAL_PENDING, TemplateStatus.REVISION, TemplateStatus.SUBMITTED, TemplateStatus.COMPLETED, TemplateStatus.CANCELED].includes(status);
            write = TemplateStatus.REVISION === status;
        } else if (cmaRole === CMARole.APPROVER) {
            read = [TemplateStatus.APPROVAL_PENDING, TemplateStatus.REVISION, TemplateStatus.SUBMITTED, TemplateStatus.COMPLETED, TemplateStatus.CANCELED].includes(status);
            write = TemplateStatus.APPROVAL_PENDING === status;
        } else if (cmaRole === CMARole.CS_ADMIN) {
            read = [TemplateStatus.SUBMITTED, TemplateStatus.COMPLETED].includes(status);
        }
        return {read, write, edit};
    }

export const showComments = (programContainer: ProgramContainer) => {
    const access = commentsAccessible(programContainer);
    if (!(access.read || access.edit || access.write)) return false;
    if (access.read && !access.edit && !access.write) {
        return programContainer.Entity?.comments?.filter(c => c.func === programContainer.HeaderConfig?.func && c.category === programContainer.HeaderConfig.category)?.length > 0;
    }
    return true;
}
